import { useEffect } from "react"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { ShieldX } from "lucide-react"
import { useNavigate } from "react-router-dom"

import { useAdminAuth } from "../hooks/use-admin-auth"

interface AdminRouteGuardProps {
  children: React.ReactNode
}

/**
 * Componente para proteger rotas que requerem permissão de ADMIN
 */
export function AdminRouteGuard({ children }: AdminRouteGuardProps) {
  const { isAdmin, user } = useAdminAuth()
  const navigate = useNavigate()

  useEffect(() => {
    // Se não é admin, redireciona para o dashboard
    if (user && !isAdmin) {
      navigate("/dashboard", { replace: true })
    }
  }, [isAdmin, user, navigate])

  // Se ainda não carregou o usuário, mostra loading
  if (!user) {
    return (
      <div className="flex min-h-96 items-center justify-center">
        <div className="border-primary h-8 w-8 animate-spin rounded-full border-b-2"></div>
      </div>
    )
  }

  // Se não é admin, mostra mensagem de acesso negado
  if (!isAdmin) {
    return (
      <div className="flex min-h-96 items-center justify-center p-6">
        <Alert className="max-w-md">
          <ShieldX className="h-4 w-4" />
          <AlertDescription>
            Acesso negado. Você precisa de permissões de administrador para acessar esta área.
          </AlertDescription>
        </Alert>
      </div>
    )
  }

  // Se é admin, renderiza os children
  return <>{children}</>
}
